import 'whatwg-fetch'

export default fetch // eslint-disable-line no-undef



// WEBPACK FOOTER //
// ./client/src/util/fetch.js